module.exports = __webpack_public_path__ + "media/home2-right.301c2186.mp4";